import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../Services/storage.service';

@Component({
  selector: 'app-congres-virtuel-main',
  templateUrl: './congres-virtuel-main.component.html',
  styleUrls: ['./congres-virtuel-main.component.scss']
})
export class CongresVirtuelMainComponent implements OnInit {

  loginBoxShow = {display:false};
  vpdata = {display:false};

  con_user = null;

  constructor(private router:Router, private storagedata:StorageService) {
    this.con_user = storagedata.getCongresConUser();
   }

  ngOnInit() {
  }

  emptyLink($event){
    $event.preventDefault();
  }

  showLoginBox(){
    this.con_user ? this.router.navigateByUrl('/congres-virtuel/welcome') : this.loginBoxShow.display = true;
  }

  goToRegisterPage(){
    this.con_user ? alert('Vous êtes déjà connecté!') : this.router.navigateByUrl('/congres-virtuel/auth');
  }

  showVidPopup(){
    //this.vpdata.display = true;
  }

}
